import { schema } from 'normalizr';

const user = new schema.Entity('user');

export default user;
